(function () {
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  var BTN = '#btn-preregister, .pre-register-button, .product-form__submit';
  var TAP = BTN + ', .txb a';

  function speed() {
    var title = document.querySelector('.race-home h1#pageTitle, .bp .bp-title');
    if (!title || title.classList.contains('fx-speed')) return;
    title.classList.add('fx-speed');
    var rest = title.querySelector('.rh-h1-rest') || title;
    var walker = document.createTreeWalker(rest, NodeFilter.SHOW_TEXT);
    var last = null;
    while (walker.nextNode()) if (walker.currentNode.nodeValue.trim()) last = walker.currentNode;
    if (last && motionOk) {
      var m = last.nodeValue.match(/^([\s\S]*?)(\d+)(\s*)$/);
      if (m) {
        var num = document.createElement('span');
        num.className = 'fx-num';
        num.textContent = m[2];
        last.nodeValue = m[1];
        last.parentNode.insertBefore(document.createTextNode(m[3]), last.nextSibling);
        last.parentNode.insertBefore(num, last.nextSibling);
      }
    }
    if (!motionOk) return;
    var lines = document.createElement('span');
    lines.className = 'fx-lines';
    lines.setAttribute('aria-hidden', 'true');
    lines.innerHTML = '<b></b><b></b><b></b><b></b>';
    title.insertBefore(lines, title.firstChild);
    placeLines(title, lines);
    var queued = false;
    var queue = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; placeLines(title, lines); });
    };
    if (window.ResizeObserver) new ResizeObserver(queue).observe(title);
    window.addEventListener('resize', queue, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  }

  /* Speed lines sit left of the title text, ending GAP px before it.
     Left/start aligned: default stylesheet geometry, hidden when the visible
     room left of the text is under MIN px.
     Centered: anchored to the line with the most room on its left, sized to
     that room and limited to that line's band. */
  var GAP = 10, MIN = 64, BAND = 0.27;

  function untransformed(el, fn) {
    var held = [];
    if (el.getAnimations) {
      el.getAnimations({ subtree: true }).forEach(function (a) {
        var fx = a.effect;
        if (!fx || !fx.target || fx.target.closest('.fx-lines')) return;
        var end = fx.getComputedTiming().endTime;
        if (!isFinite(end)) return;
        held.push([a, a.currentTime]);
        a.currentTime = end;
      });
    }
    try { return fn(); } finally {
      held.forEach(function (h) { h[0].currentTime = h[1]; });
    }
  }

  function textLines(title) {
    var range = document.createRange();
    var walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
    var out = [];
    while (walker.nextNode()) {
      var n = walker.currentNode;
      if (!n.nodeValue.trim()) continue;
      range.selectNodeContents(n);
      Array.prototype.forEach.call(range.getClientRects(), function (r) {
        if (r.width < 1) return;
        for (var i = 0; i < out.length; i++) {
          var l = out[i];
          if (Math.abs(l.top - r.top) < r.height / 3) {
            l.left = Math.min(l.left, r.left); l.right = Math.max(l.right, r.right);
            l.top = Math.min(l.top, r.top); l.bottom = Math.max(l.bottom, r.bottom);
            return;
          }
        }
        out.push({ left: r.left, right: r.right, top: r.top, bottom: r.bottom });
      });
    }
    return out;
  }

  function clipLeft(el) {
    var x = 0;
    for (var p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      if (getComputedStyle(p).overflowX !== 'visible') x = Math.max(x, p.getBoundingClientRect().left);
    }
    return x;
  }

  function placeLines(title, lines) {
    var s = lines.style;
    var g = untransformed(title, function () {
      var box = title.getBoundingClientRect();
      var ls = textLines(title);
      if (!ls.length) return null;
      var edge = clipLeft(title);
      var align = getComputedStyle(title).textAlign;
      if (align !== 'center') {
        var left = Math.min.apply(null, ls.map(function (l) { return l.left; }));
        return { mode: 'default', room: left - GAP - edge };
      }
      var best = ls.reduce(function (a, b) { return b.left > a.left ? b : a; });
      var h = best.bottom - best.top;
      return {
        mode: 'center',
        room: best.left - GAP - edge,
        right: best.left - GAP - box.left,
        top: best.top + h * BAND - box.top,
        height: h * (1 - 2 * BAND),
        max: window.innerWidth * 0.3
      };
    });
    s.left = s.right = s.top = s.bottom = s.width = s.height = s.margin = '';
    if (!g || g.room < MIN) { s.visibility = 'hidden'; return; }
    s.visibility = '';
    if (g.mode !== 'center') return;
    var w = Math.min(g.max, g.room);
    s.right = 'auto'; s.bottom = 'auto'; s.margin = '0';
    s.left = (g.right - w) + 'px';
    s.width = w + 'px';
    s.top = g.top + 'px';
    s.height = g.height + 'px';
  }

  function rev() {
    Array.prototype.forEach.call(document.querySelectorAll(BTN), function (btn) {
      if (btn.classList.contains('fx-rev')) return;
      btn.classList.add('fx-rev');
      var tach = document.createElement('span');
      tach.className = 'fx-tach';
      tach.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 10; i++) {
        var seg = document.createElement('i');
        seg.style.setProperty('--i', i);
        tach.appendChild(seg);
      }
      var streaks = document.createElement('span');
      streaks.className = 'fx-streaks';
      streaks.setAttribute('aria-hidden', 'true');
      streaks.innerHTML = '<b></b><b></b><b></b><b></b>';
      btn.appendChild(tach);
      btn.appendChild(streaks);
      btn.addEventListener('touchstart', function () { btn.classList.add('is-revving'); }, { passive: true });
      var off = function () { setTimeout(function () { btn.classList.remove('is-revving'); }, 600); };
      btn.addEventListener('touchend', off, { passive: true });
      btn.addEventListener('touchcancel', off, { passive: true });
    });
  }

  function roost() {
    if (!motionOk || !Element.prototype.animate) return;
    var COLORS = ['#7a5130', '#9c6c40', '#b98a5a', '#d2ad80', '#5c3c22'];
    var layer = document.createElement('div');
    layer.className = 'fx-roost-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    function burst(btn) {
      var r = btn.getBoundingClientRect();
      var small = window.innerWidth < 750;
      var ox = r.left + (small ? r.width * 0.3 : 10), oy = r.bottom - 6;
      var n = small ? 24 : 36;
      var i, p, s;
      for (i = 0; i < 4; i++) {
        p = document.createElement('i');
        s = 40 + Math.random() * 34;
        p.className = 'fx-puff';
        p.style.cssText = 'left:' + (ox - s / 2) + 'px;top:' + (oy - s / 2) + 'px;width:' + s + 'px;height:' + s + 'px';
        layer.appendChild(p);
        p.animate([
          { transform: 'translate(0,0) scale(.4)', opacity: 0.9 },
          { transform: 'translate(' + (-30 - i * 22) + 'px,' + (-8 - i * 6) + 'px) scale(1.7)', opacity: 0 }
        ], { duration: 650 + i * 90, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }).onfinish = remover(p);
      }
      for (i = 0; i < n; i++) {
        p = document.createElement('i');
        s = 3 + Math.random() * 6;
        p.style.cssText = 'left:' + ox + 'px;top:' + oy + 'px;width:' + s + 'px;height:' + (s * (0.6 + Math.random() * 0.8)).toFixed(1) + 'px;' +
          'background:' + COLORS[i % COLORS.length] + ';border-radius:' + Math.round(Math.random() * 50) + '%';
        layer.appendChild(p);
        var vx = small ? -(40 + Math.random() * 220) : -(160 + Math.random() * 360);
        var vy = -(140 + Math.random() * 300);
        var g = 900, T = 0.5 + Math.random() * 0.35, spin = (Math.random() * 540) | 0;
        var frames = [];
        for (var k = 0; k <= 8; k++) {
          var t = T * k / 8;
          frames.push({
            transform: 'translate(' + (vx * t).toFixed(1) + 'px,' + (vy * t + 0.5 * g * t * t).toFixed(1) + 'px) rotate(' + ((spin * k / 8) | 0) + 'deg)',
            opacity: k < 5 ? 1 : 1 - (k - 4) / 4
          });
        }
        p.animate(frames, { duration: T * 1000, easing: 'linear', fill: 'forwards' }).onfinish = remover(p);
      }
      btn.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
        { duration: 160, easing: 'cubic-bezier(.3,1.6,.5,1)' }
      );
    }

    function remover(el) {
      return function () { if (el.parentNode) el.parentNode.removeChild(el); };
    }

    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest(TAP);
      if (b && !b.disabled) burst(b);
    }, { passive: true });
  }

  function init() {
    speed();
    rev();
  }

  roost.done = false;
  function start() {
    init();
    if (!roost.done) { roost.done = true; roost(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', init);
})();
